import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reason-master',
  templateUrl: './reason-master.component.html',
  styleUrls: ['./reason-master.component.css']
})
export class ReasonMasterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
